export const CloseIcon = ({
  width = 24,
  height = 24,
  className,
  title = "Close",
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
      focusable="false"
      {...rest}>
      <title>{title}</title>
      <g clipPath="url(#clip0_2497_8725)">
        <path
          d="M4.9629 4.89648C5.15819 4.70153 5.47485 4.70132 5.67 4.89648L12.0664 11.2929L18.3979 4.96139C18.5932 4.76613 18.9098 4.76613 19.105 4.96139C19.3 5.15667 19.3002 5.47334 19.105 5.66849L12.7735 12L19.105 18.3315C19.3002 18.5267 19.3 18.8433 19.105 19.0386C18.9098 19.2339 18.5932 19.2339 18.3979 19.0386L12.0664 12.7071L5.67 19.1035C5.47485 19.2987 5.15818 19.2985 4.9629 19.1035C4.76764 18.9083 4.76764 18.5917 4.9629 18.3964L11.3593 12L4.9629 5.60358C4.76764 5.40832 4.76764 5.09174 4.9629 4.89648Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2497_8725">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
